// Portfolio Administration v1.0 PR 4a §7.6a — the 10 calendar categories.
// SourceType values emitted by the 138 generators bucket into these 10
// surface categories that the user can filter on.

export type DueDateCategoryKey =
  | "borrower-payment"
  | "insurance"
  | "ucc"
  | "tax-financial"
  | "regulatory"
  | "capital-markets"
  | "vendor"
  | "internal-review"
  | "closing-derived"
  | "other";

export interface DueDateCategory {
  key: DueDateCategoryKey;
  label: string;
  /** sourceType prefix tokens (case-insensitive) used to classify items. */
  match: readonly string[];
}

export const DUE_DATE_CATEGORIES: readonly DueDateCategory[] = [
  {
    key: "borrower-payment",
    label: "Borrower payment dates",
    match: ["BorrowerPayment", "Payment.", "MonthlyServicing"],
  },
  {
    key: "insurance",
    label: "Insurance dates",
    match: ["Insurance"],
  },
  {
    key: "ucc",
    label: "UCC dates",
    match: ["UCC", "Ucc"],
  },
  {
    key: "tax-financial",
    label: "Tax & financial reporting",
    match: ["Tax", "FinancialReporting", "Compliance.Quarterly", "Compliance.Annual"],
  },
  {
    key: "regulatory",
    label: "Regulatory",
    match: ["Regulatory", "Licensing", "SOX"],
  },
  {
    key: "capital-markets",
    label: "Capital markets",
    match: ["CapitalMarkets", "InvestorReport"],
  },
  {
    key: "vendor",
    label: "Vendor",
    match: ["Vendor", "VFI"],
  },
  {
    key: "internal-review",
    label: "Internal review",
    match: ["InternalReview", "PortfolioReview", "QaReview", "Audit"],
  },
  {
    key: "closing-derived",
    label: "Closing-derived",
    match: ["ClosingDerived", "PostClose", "Setup"],
  },
  {
    key: "other",
    label: "Other",
    match: [],
  },
];

export function categorize(sourceType: string): DueDateCategoryKey {
  const lower = sourceType.toLowerCase();
  for (const cat of DUE_DATE_CATEGORIES) {
    for (const m of cat.match) {
      if (lower.startsWith(m.toLowerCase()) || lower.includes(`.${m.toLowerCase()}`)) {
        return cat.key;
      }
    }
  }
  return "other";
}

export type Severity =
  | "Catastrophic"
  | "Compliance-EOD"
  | "Compliance-Cure-Available"
  | "Operational"
  | "Information"
  | "minor";

export const SEVERITY_OPTIONS: readonly Severity[] = [
  "Catastrophic",
  "Compliance-EOD",
  "Compliance-Cure-Available",
  "Operational",
  "Information",
];

export type DueDateStatusFilter = "Open" | "In-Progress" | "Completed" | "Waived" | "Overdue";

export const STATUS_OPTIONS: readonly DueDateStatusFilter[] = [
  "Open",
  "In-Progress",
  "Completed",
  "Waived",
  "Overdue",
];
